import script from "./consumeRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./consumeRecord.vue?vue&type=script&setup=true&lang=js"

import "./consumeRecord.vue?vue&type=style&index=0&id=b051dc1e&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b051dc1e"]])

export default __exports__